<template>
  <div class="text-gray-500 text-center mx-auto w-3/4 max-w-[350px]">
    <div class="flex justify-center my-4">
      <PermissionStatusCircle
        :icon="biometric.isFaceID ? 'icon-face-id' : 'icon-touch-id'"
        ready
      ></PermissionStatusCircle>
    </div>
    <div class="font-bold text-lg text-gray-700">Biometric Login</div>
    <p class="my-6">
      Your device's biometric services are used to <span class="text-gray-700 font-medium">easily</span> log back in.
    </p>
    <div v-if="biometric.isAvailable">
      <div class="text-lg font-bold text-gray-700">Good to go!</div>
      <p>
        NCSS has the necessary access to Biometric Services<br /><span class="text-gray-700 font-bold">Thank you</span>
      </p>
    </div>
    <PermissionDialog v-else>Allow "NCSS" to use Biometric Login?</PermissionDialog>
  </div>
</template>

<script setup lang="ts">
import PermissionStatusCircle from '@/components/permissions/PermissionStatusCircle.vue';
import PermissionDialog from './PermissionDialog.vue';
import { useBiometrics } from '@/stores/biometrics.store';

const biometric = useBiometrics();
</script>

<style scoped></style>
